import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getBookingInsights = createAsyncThunk('bookingInsight/getBookingInsights',
  async ({ params }: any) => {
    const paramText = new URLSearchParams(params)
    const url = `/v1/reports/booking-insights?${paramText}`
    const response: AxiosResponse<BookingInsight> = await instance.get(url)
    return {
      type: params.insightType,
      data: response.data
    } as PayloadWithType<BookingInsight>
  })